import React from 'react'
import { Progress } from 'antd'
import { ProcessingProgress, processingProgressMeter, processingProgressText } from './processing-progress'
import './processing-progress-indicator.css'

export default function ProcessingProgressIndicator({ progress }: { progress: ProcessingProgress }) {
  const percent = processingProgressMeter(progress)
  const text = processingProgressText(progress)
  return <div className="supply-processing-progress" role="status" aria-live="polite">
    {percent == null
      ? <div className="supply-processing-progress__indeterminate" role="progressbar" aria-label={text || 'Выполняется текущая стадия'} />
      : <Progress percent={percent} showInfo={false} size="small" status="active" aria-label={text} />}
    {text && <small>{text}</small>}
  </div>
}
